import Constant from '@/const';
import axios from 'axios';

const getReturnStatus = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/returnstatus/outpatient'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

const getReturnStatusInpatient = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/returnstatus/inpatient'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

const getAwareness = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/awarness'),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export { getReturnStatus, getReturnStatusInpatient, getAwareness };
